import React from "react";
import { Panel, Kicker, DataTable } from "../ciWidgets";

const LEVELS = ["low", "medium", "high"];

export const RisksTab = ({ report }) => {
  const risks = report.risk_register || [];

  const heat = {};
  risks.forEach((r, i) => {
    const key = `${r.probability || "medium"}|${r.impact || "medium"}`;
    heat[key] = heat[key] || [];
    heat[key].push(i + 1);
  });

  const cellColor = (p, im) => {
    const score = LEVELS.indexOf(p) + LEVELS.indexOf(im);
    if (score >= 3) return "bg-red-500/25 border-red-400/30";
    if (score === 2) return "bg-amber-500/20 border-amber-400/30";
    return "bg-emerald-500/12 border-emerald-400/25";
  };

  return (
    <div className="space-y-6" data-testid="ci-tab-risks">
      <div className="grid lg:grid-cols-[380px_1fr] gap-6">
        <Panel className="p-7">
          <Kicker className="mb-5">Risk heatmap</Kicker>
          <div className="grid grid-cols-[auto_1fr_1fr_1fr] gap-1.5 text-center">
            <div />
            {LEVELS.map((im) => (
              <div key={im} className="text-[10px] tracking-[0.14em] uppercase text-white/40 font-semibold py-1">{im}</div>
            ))}
            {[...LEVELS].reverse().map((p) => (
              <React.Fragment key={p}>
                <div className="text-[10px] tracking-[0.12em] uppercase text-white/40 font-semibold flex items-center pr-2" style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}>
                  {p}
                </div>
                {LEVELS.map((im) => (
                  <div key={im} className={`h-20 rounded-lg border flex flex-wrap items-center justify-center gap-1 p-1 ${cellColor(p, im)}`}>
                    {(heat[`${p}|${im}`] || []).map((n) => (
                      <span key={n} className="w-6 h-6 rounded-full bg-[#0a1220] border border-white/25 text-[11px] text-white flex items-center justify-center tabular-nums">
                        {n}
                      </span>
                    ))}
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
          <div className="flex justify-between text-[10px] tracking-[0.14em] uppercase text-white/35 mt-2">
            <span>← Probability</span>
            <span>Impact →</span>
          </div>
        </Panel>

        <Panel className="p-7 overflow-hidden">
          <Kicker className="mb-4">Board risk register</Kicker>
          <div className="space-y-4 max-h-[560px] overflow-y-auto pr-2">
            {risks.map((r, i) => (
              <div key={i} className="rounded-lg border border-white/10 bg-[#060d18] p-5" data-testid={`ci-risk-card-${i}`}>
                <div className="flex items-start justify-between gap-3 mb-2">
                  <div className="flex items-center gap-3">
                    <span className="w-7 h-7 rounded-full bg-white/8 border border-white/20 text-[12px] text-white flex items-center justify-center tabular-nums shrink-0">
                      {i + 1}
                    </span>
                    <div>
                      <div className="text-[14px] font-semibold text-white leading-snug">{r.risk}</div>
                      <div className="text-[11px] text-white/40">{r.category} · velocity {r.velocity} · {r.horizon}</div>
                    </div>
                  </div>
                  <span
                    className={`shrink-0 text-[10px] font-bold tracking-[0.1em] uppercase rounded-full border px-2.5 py-1 ${
                      r.residual_risk === "high" ? "text-red-300 border-red-400/30 bg-red-400/[0.08]" : r.residual_risk === "low" ? "text-emerald-300 border-emerald-400/30 bg-emerald-400/[0.08]" : "text-amber-300 border-amber-400/30 bg-amber-400/[0.08]"
                    }`}
                  >
                    Residual {r.residual_risk}
                  </span>
                </div>
                <p className="text-[13px] text-white/60 leading-relaxed mb-3">{r.description}</p>
                <div className="grid sm:grid-cols-2 gap-x-6 gap-y-1.5 text-[12px]">
                  <div><span className="text-white/40">Cause:</span> <span className="text-white/65">{r.cause}</span></div>
                  <div><span className="text-white/40">Prob / Impact:</span> <span className="text-white/65">{r.probability} / {r.impact}</span></div>
                  <div><span className="text-white/40">Controls:</span> <span className="text-white/65">{r.controls} ({r.control_effectiveness})</span></div>
                  <div><span className="text-white/40">Early warning:</span> <span className="text-white/65">{r.early_warning}</span></div>
                  <div className="sm:col-span-2"><span className="text-teal-300 font-semibold">Mitigation:</span> <span className="text-white/70">{r.mitigation}</span></div>
                  <div><span className="text-white/40">Owner:</span> <span className="text-amber-200">{r.owner}</span></div>
                </div>
              </div>
            ))}
          </div>
        </Panel>
      </div>
    </div>
  );
};
